import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { h3 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import ShareButtonsStyles from '@stories/Components/Misc/ShareButtons/ShareButtons.styles';
import TrustpilotBlockStyles from '@stories/Components/Misc/TrustpilotBlock/TrustpilotBlock.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --sectionSpacing: 48px;

  position: relative;
  overflow: hidden;

  @media ${from(Device.TabletLarge)} {
    min-height: 460px;
  }

  ${ShareButtonsStyles.Container} {
    margin-top: 20px;
  }
`;
const Inner = styled.div `
  ${baseGrid};
  align-items: center;

  @media ${from(Device.TabletLarge)} {
    min-height: calc(460px - 96px);
  }
`;
const BackgroundImage = styled.div `  
`;
const Overlay = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: ${rgba(brand.black, 0.6)};
`;
const ContentColumn = styled.div `
  position: relative;
  z-index: 1;
  grid-column: 1 / span 12;
  max-width: 696px;
  color: ${brand.white};

  ${TrustpilotBlockStyles.Container} {
    margin-top: 24px;
  }

  @media ${until(Device.TabletLarge)} {
    order: 2;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 4 / span 6;
  }
`;
const ImageWrapper = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
const Image = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  background: ${brand.lightGrey};
  height: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;
`;
const Title = styled.h1 `
  ${h3}
  margin-bottom: 0.5em;
`;
const DateContainer = styled.span `
  ${fonts.montserrat.regular}
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 15px;
`;
const UpdatedDateContainer = styled.div `
  ${fonts.montserrat.regular}
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 15px;
`;
const Date = styled.time `
  ${fonts.montserrat.regular}
`;
const AuthorArea = styled.div `
  display: grid;
  grid-template-columns: 70px auto;
  align-items: center;
  margin-top: 10px;

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 80px auto;
  }
`;
const AuthorImage = styled.div `

`;
const PersonImage = styled.img `
  display: block;
  border: 2px solid ${brand.white};
  border-radius: 100000000000px;
  height: 64px;
  width: 64px;
`;
const NoImage = styled.div `
  ${fonts.montserrat.semiBold};
  border: 2px solid ${brand.white};
  border-radius: 100000000000px;
  height: 64px;
  width: 64px;
  background-color: ${brand.orange};
  color: ${brand.white};
  line-height: 58px;
  text-align: center;
  font-size: 32px;
`;
const AuthorDetails = styled.div `
  grid-column: 2;
`;
const AuthorName = styled.a `
  ${fonts.montserrat.bold};
  margin-bottom: 5px;
  color: ${brand.white};
  text-underline-position: under;
  display: block;
`;
const AuthorJobTitle = styled.p `
  ${fonts.montserrat.regular};
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 0;
`;
const MediaArticleBannerStyles = {
    AuthorArea,
    AuthorDetails,
    AuthorImage,
    AuthorJobTitle,
    AuthorName,
    BackgroundImage,
    Container,
    ContentColumn,
    Date,
    DateContainer,
    Image,
    ImageWrapper,
    Inner,
    NoImage,
    Overlay,
    PersonImage,
    Title,
    UpdatedDateContainer
};
export default MediaArticleBannerStyles;
